export const environment = {
  name: 'production',
  production: true,
  staging: false,
  DATE_FORMAT: 'dd.MM.yyyy',
  BASE_URL: 'https://api.ltytech.ch/',
  USERAPIENDPOINT: 'https://api.ltytech.ch/api/ims/v1/',
  COMMUNICATORAPIURL: 'https://api.ltytech.ch/api/communicator/v1/',
  DOCUMENTAPIURL: 'https://api.ltytech.ch/api/document-store/v1/',
  INSURANCEAPIURL: 'https://api.ltytech.ch/api/insurance/v1/',
  CATALOGUEAPIURL: 'https://api.ltytech.ch/api/catalogue/v1/',
  ROLEAPIENDPOINT: 'https://api.ltytech.ch/api/role-access/v1/',

  VERSION: '1.0.14',

  tokenValidityTimeMinutes: 60,
  // Brevo form submission endpoint (https://sibforms.com/serve/<id>). Empty = sync disabled.
  BREVO_FORM_URL:
    'https://8a456507.sibforms.com/serve/MUIFAHDwtxlEKCpdEbu1p09PNS70XHF-2C5TZ63Q0KKR184wVfsY-nclPSc9CCVxIPrDbYLdcsKar9zrkn1Q4vUbAV_qnmbzC5EwDq-UlRBUD12bCM7uJ0-773UWm_cnPqes32XzHw7lohi2EkG89fNDba7YWNCQ7zudQiVyqHVbxHxBQaVMZwFrOgYuso-XQ_4UQrEDusLBbYD8nQ==',
  // Kill switch for the Brevo lead sync: true skips it entirely, whatever BREVO_FORM_URL says.
  SKIP_BREVO_SYNC: false,
  SHOWCASE_WEBSITE_URL: 'https://www.lty.ch/',
  CALENDLY_URL: 'https://calendly.com/v-thetaz-lty/lty?hide_gdpr_banner=1',
  // Referrer for which the top bar will make a back() call instead of redirecting to the dashboard
  BACKABLE_REFERRER: 'lty.ch',
};
